
import redesignImg from '../images/redesign.webp'

function Footer() {
	return (
	<>
		<footer class="footer_area">
		<div class="container">
			<div class="f_inner">
				<div class="f_left">
					<p>Disclaimer: 18+</p>
					<p>This website is intended for users aged 18 and above. By accessing and using Wicket Dreams Fantasy, you confirm that you are at least 18 years old. We encourage responsible gaming and urge our users to play within their limits. Daily fantasy sports are banned in Andhra Pradesh, Assam, Nagaland, Orissa, Sikkim, and Telangana. Please be aware that participation in any fantasy cricket leagues or related activities involves financial risk. If you feel that your gaming habits are becoming problematic or you need support, we recommend seeking assistance from professional services specializing in gambling addiction. By continuing to use this website, you acknowledge and agree to our terms and conditions, including the age restrictions. Thank you for your understanding.</p>
					<p>BlueLakeEscapesFI</p>
					<p>
						<a href="#">+497312543602</a>
					</p>
				</div>
				<div class="f_right">
					<h3>18+</h3>
				</div>
			</div>
		</div>
	</footer>
	</>
	)
}

export default Footer
